var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 15.4999,
    x2: 21.95808,
    y2: 15.5,
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,10.84605V16a2,2,0,0,0,2,2H16.76894a9.99963,9.99963,0,0,0,2.42536-.29858l.912-.228A2.5,2.5,0,0,0,22,15.04806v-.1525a2.5,2.5,0,0,0-2.00971-2.45145l-2.21436-.44288a3.99981,3.99981,0,0,1-1.43433-.59412L11.48286,8.168a1,1,0,0,0-1.00192-.06237l-1.1828.5914a.99992.99992,0,0,0-.44721.44721l-.57454,1.14907a1,1,0,0,1-.89442.55279H5l-.58579-.58579a1.41417,1.41417,0,0,0-1-.41421H3A1,1,0,0,0,2,10.84605Z",
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(24 24) rotate(-180)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.88e1a8eee74073cdbc0c8abd1fb8875f.svg";
export { ForwardRef as ReactComponent };